module.exports = __webpack_public_path__ + "img/vegetable-parsnips-190x100.ae1a8473.jpg";